import React, { useEffect, useRef, useState } from 'react';
import { toast } from '../../../../ui/toast';
import { Button } from '../../../../ui';
import { createJob, getJob } from '../../../../utils/api_service/job_api';
import { formatDateTime } from '../../../../utils/helpers/time';
import {
  Settings,
  TopicBasedGeneratorJob,
} from '../../../../utils/types/content_manager_types';
import { GenerateProperties } from '../GenerateProperties/GenerateProperties';
import { QuestionsList } from '../question_list';
import { SessionTitle } from '../session_title';
import { TopicInput } from '../topic_input';

export const TopicQuestionGenerate = () => {
  const questionsCount = useRef(0);
  const [topic, setTopic] = useState<string>('');
  const [defaultSessionTitle, setDefaultSessionTitle] = useState<string>(
    `${topic ? topic : ''}-`,
  );
  const [sessionTitle, setSessionTitle] = useState<string>(defaultSessionTitle);
  const [questionsLoading, setQuestionsLoading] = useState<boolean>(false);
  const [errorJob, setErrorJob] = useState<boolean>(false);

  useEffect(() => {
    const currentDateTimeString = formatDateTime(new Date());
    const titlePrefix = topic ? topic : 'Question generation';
    setDefaultSessionTitle(`${titlePrefix} - ${currentDateTimeString}`);
  }, [topic]);

  const [editGenerateProperties, setEditGenerateProperties] =
    useState<Settings>({
      level: '',
      jobTitle: '',
      questionType: '',
      time: 0,
      points: 0,
    });
  const [job, setJob] = useState<TopicBasedGeneratorJob>({
    id: '',
    generationType: '',
    _cls: '',
    title: '',
    organizationId: '',
    status: 'Uploading...',
    creationDateTime: 0,
    topic: '',
    questions: [],
  });

  const pollJob = (id: string) => {
    getJob(id)
      .then((response) => {
        setJob(response);
        if (response.status && response.status.includes('Error')) {
          setQuestionsLoading(false);
          setErrorJob(true);
          toast.error(`${response.status} Please Try Again`, {
            position: 'bottom-center',
          });
        } else {
          questionsCount.current = response.questions?.length || 0;
          if (questionsCount.current === 0) {
            setTimeout(() => {
              pollJob(id);
            }, 5000);
          } else {
            setQuestionsLoading(false);
          }
        }
      })
      .catch(() => {
        toast.error('Error. Please try again', { position: 'bottom-center' });
        setErrorJob(true);
      });
  };

  const generateQuestions = () => {
    setQuestionsLoading(true);
    setErrorJob(false);
    createJob(sessionTitle, topic, 'topic', editGenerateProperties).then(
      (response) => {
        if (response.questions && response.questions.length !== 0) {
          setJob(response);
          setQuestionsLoading(false);
        } else {
          pollJob(response.id);
        }
      },
    );
  };

  return (
    <div className='space-y-3'>
      <SessionTitle
          sessionTitle={sessionTitle}
          setSessionTitle={setSessionTitle}
          defaultValue={defaultSessionTitle}
          disabled={
            questionsLoading || (job.questions && job.questions.length > 0)
          }
      />
      <div className='rounded-lg border border-slate-200 bg-white p-3 shadow-sm'>
        <div className='mb-2'>
          <p className='text-sm font-extrabold text-slate-900'>
            Topic Skills
          </p>
          <p className='text-xs text-slate-500'>
            Add a main skill and optional sub-skills to guide generation.
          </p>
        </div>
        <TopicInput
            setTopic={setTopic}
            disabled={
              questionsLoading || (job.questions && job.questions.length > 0)
            }
            placeholder='Type a skill and press enter...'
        />
      </div>
      <GenerateProperties
          setEditGenerateProperties={setEditGenerateProperties}
          job={job}
      />
      <div className='flex justify-end'>
        <Button
            onClick={() => generateQuestions()}
            variant='primary'
            label='Generate Questions'
            disabled={
              editGenerateProperties.jobTitle === '' ||
            topic === '' ||
            sessionTitle === '' ||
            editGenerateProperties.level === '' ||
            (job.questions && job.questions.length > 0) ||
            questionsLoading
            }
        />
      </div>
      <div>
        <QuestionsList
            job={job}
            questionsLoading={questionsLoading}
            setJob={setJob}
            errorJob={errorJob}
        />
      </div>
    </div>
  );
};
